import { Component, inject, output } from '@angular/core'
import { MatDialog } from '@angular/material/dialog'
import { MatButtonModule } from '@angular/material/button'
import { MatIconModule } from '@angular/material/icon'
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner'
import { MatRippleModule } from '@angular/material/core'
import { MatTooltipModule } from '@angular/material/tooltip'

import { ChatState } from '@states/chat-state'
import { ChatNewConversation } from '@components/chat-new-conversation'
import { ConversationTypeIconPipe } from '@pipes/conversation-type-icon-pipe'
import { ConversationTypeLabelPipe } from '@pipes/conversation-type-label-pipe'
import { FormatChatTimePipe } from '@pipes/format-chat-time-pipe'

@Component({
	selector: 'chat-conversation-list',
	templateUrl: './chat-conversation-list.html',
	styleUrl: './chat-conversation-list.scss',
	standalone: true,
	imports: [
		MatButtonModule,
		MatIconModule,
		MatProgressSpinnerModule,
		MatRippleModule,
		MatTooltipModule,
		ConversationTypeIconPipe,
		ConversationTypeLabelPipe,
		FormatChatTimePipe,
	],
})
export class ChatConversationList {
	readonly #dialog = inject(MatDialog)
	readonly #chatState = inject(ChatState)

	readonly refresh = output<void>()
	readonly select = output<string>()

	readonly conversations = this.#chatState.conversations
	readonly activeUuid = this.#chatState.activeConversationUuid
	readonly isLoading = this.#chatState.isLoadingConversations

	selectConversation(uuid: string): void {
		this.select.emit(uuid)
	}

	refreshConversations(): void {
		this.refresh.emit()
	}

	openNewConversationDialog(): void {
		this.#dialog.open(ChatNewConversation, {
			width: '100%',
			maxWidth: '30rem',
			backdropClass: 'custom-backdrop',
			autoFocus: false,
		})
	}
}
